import { addDays, subDays } from 'date-fns';

export const statusMap = {
  EXPIRED: {
    color: '#F7D4D7',
    label: 'VENCIDO',
    statusText: 'ONTEM',
    date: subDays(new Date(), 1).toLocaleDateString('pt-BR')
  },
  ON_DATE: {
    color: '#FFF2CC',
    label: 'À VENCER',
    statusText: 'HOJE',
    date: new Date().toLocaleDateString('pt-BR')
  },
  VALID: {
    color: '#D2F9D6',
    label: 'VENCIMENTO PRÓXIMO',
    mobileLabel: 'PRÓXIMO',
    statusText: 'AMANHÃ',
    date: addDays(new Date(), 1).toLocaleDateString('pt-BR')
  }
};

export const expirationMock = [
  {
    id: 1,
    quantity: '9.999',
    status: 'EXPIRED',
    date: '17/06/2025'
  },
  {
    id: 2,
    quantity: '9.999',
    status: 'ON_DATE',
    date: '18/06/2025'
  },
  {
    id: 3,
    quantity: '9.999',
    status: 'VALID',
    date: '19/06/2025'
  }
];
